<app-tab-layout [loading]="loading()" [error]="error">
  <app-api-table
    [endpoint]="'/activities/tables/overview'"
    [name]="name"
    chartColumn="Name"
    [onRowClick]="onRowClick"
  >
  </app-api-table>
</app-tab-layout>

<app-modal
  [title]="modalTitle"
  size="md"
  [opened]="isModalOpen()"
  (closeTrigger)="onModalClose()"
>
  <div class="activities-modal-content">
    @if (isModalLoading()) {
      <div class="modal-loading">
        <app-loading-spinner />
      </div>
    } @else if (activities.length === 0) {
      <div class="no-activities">
        <p>{{ dictionaryService.get('NoDataFound') }}</p>
      </div>
    } @else {
      <div class="activities-list">
        @for (activity of activities; track $index) {
          <div class="activity-entry">
            <p class="activity-subcategory">{{ activity.leaveType }} {{activity.subCategory? '- ' + activity.subCategory:'' }}</p>
            <p class="activity-status-line">
              {{ dictionaryService.get('Status') }}: <span [ngClass]="getStatusClass(activity.status)">{{ getStatusLabel(activity.status) }}</span>
            </p>
            <p class="activity-date-line">
              {{ dictionaryService.get('From') }}: {{ formatDate(activity.from) }}
              | {{ dictionaryService.get('To') }}: {{ formatDate(activity.to) }}
              | {{ dictionaryService.get('Duration') }}: {{ activity.duration }}
            </p>
          </div>
        }
      </div>
    }
  </div>
</app-modal>
